const data = [
    {
        id:1,
        text: "",
        completed: false,
        value: ''
    },
    {
        id:2,
        text: null,
        completed: false,
        value: ''
    },
    {
        id:3,
        text: "",
        completed: false,
        value: ''
    },
]

export default data